export default __webpack_public_path__ + "static/media/art-m.beb27347.jpg";